// extracted by mini-css-extract-plugin
module.exports = {"notice":"styles_notice__3G4oi","txt":"styles_txt__1vfKM","steps":"styles_steps__3gmwj","btn":"styles_btn__3Mtei"};